import React from 'react';
import { connect } from 'react-redux';

// Make fade when scroll
const ScrollPrompt = (props) => {
  return (
    <div className={(props.scrollDirection == 'top') ? 'scroll-prompt top' : 'scroll-prompt'}>
      <svg version="1.1" viewBox="0 0 64 64" width="45" height="45">
        <g className="nc-icon-wrapper" fill="#ffffff">
          <polyline fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" points="60,18 32,46 4,18 " strokeLinejoin="miter"></polyline>
        </g>
      </svg>
    </div>
  );
};

export default connect(
  state => ({
    scrollDirection: state.scroll_direction
  })
)(ScrollPrompt);



// WEBPACK FOOTER //
// ./src/components/ScrollPrompt.js